import { render, staticRenderFns } from "./allocationRules.vue?vue&type=template&id=746214bd&scoped=true&"
import script from "./allocationRules.vue?vue&type=script&lang=js&"
export * from "./allocationRules.vue?vue&type=script&lang=js&"
import style0 from "./allocationRules.vue?vue&type=style&index=0&id=746214bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746214bd",
  null
  
)

export default component.exports